const FETCH_BIN_REQUEST = 'FETCH_BIN_REQUEST';
const FETCH_BIN_SUCCESS = 'FETCH_BIN_SUCCESS';
const FETCH_BIN_ERROR = 'FETCH_BIN_ERROR';
const HIDE_BIN_LOADER = 'HIDE_BIN_LOADER';
const SHOW_BIN_LOADER = 'SHOW_BIN_LOADER';
const UPLOAD_BIN_FILE_REQUEST = 'UPLOAD_BIN_FILE_REQUEST';
const UPLOAD_BIN_FILE_SUCCESS = 'UPLOAD_BIN_FILE_SUCCESS';
const UPLOAD_BIN_FILE_ERROR = 'UPLOAD_BIN_FILE_ERROR';
const SEARCH_BIN_DETAIL_REQUEST = 'SEARCH_BIN_DETAIL_REQUEST';
const SEARCH_BIN_DETAIL_SUCCESS = 'SEARCH_BIN_DETAIL_SUCCESS';
const SEARCH_BIN_DETAIL_ERROR = 'SEARCH_BIN_DETAIL_ERROR';
const UPDATE_BIN_DETAIL_REQUEST = 'UPDATE_BIN_DETAIL_REQUEST';
const UPDATE_BIN_DETAIL_SUCCESS = 'UPDATE_BIN_DETAIL_SUCCESS';
const UPDATE_BIN_DETAIL_ERROR = 'UPDATE_BIN_DETAIL_ERROR';
const DOWNLOAD_BY_ID_REQUEST = 'DOWNLOAD_BY_ID_REQUEST';
const DOWNLOAD_BY_ID_SUCCESS = 'DOWNLOAD_BY_ID_SUCCESS';
const DOWNLOAD_BY_ID_ERROR = 'DOWNLOAD_BY_ID_ERROR';
const GET_SEARCH_RECENT_BIN_REQUEST = 'GET_SEARCH_RECENT_BIN_REQUEST';
const GET_SEARCH_RECENT_BIN_SUCCESS = 'GET_SEARCH_RECENT_BIN_SUCCESS';
const GET_SEARCH_RECENT_BIN_ERROR = 'GET_SEARCH_RECENT_BIN_ERROR';

const UPLOAD_NETWORK_BIN_FILE_REQUEST = 'UPLOAD_NETWORK_BIN_FILE_REQUEST';
const UPLOAD_NETWORK_BIN_FILE_SUCCESS = 'UPLOAD_NETWORK_BIN_FILE_SUCCESS';
const UPLOAD_NETWORK_BIN_FILE_ERROR = 'UPLOAD_NETWORK_BIN_FILE_ERROR';

export {
    FETCH_BIN_REQUEST,
    FETCH_BIN_SUCCESS,
    FETCH_BIN_ERROR,
    HIDE_BIN_LOADER,
    SHOW_BIN_LOADER,
    UPLOAD_BIN_FILE_REQUEST,
    UPLOAD_BIN_FILE_SUCCESS,
    UPLOAD_BIN_FILE_ERROR,
    UPLOAD_NETWORK_BIN_FILE_REQUEST,
    UPLOAD_NETWORK_BIN_FILE_SUCCESS,
    UPLOAD_NETWORK_BIN_FILE_ERROR,
    SEARCH_BIN_DETAIL_REQUEST,
    SEARCH_BIN_DETAIL_SUCCESS,
    SEARCH_BIN_DETAIL_ERROR,
    UPDATE_BIN_DETAIL_REQUEST,
    UPDATE_BIN_DETAIL_SUCCESS,
    UPDATE_BIN_DETAIL_ERROR,
    DOWNLOAD_BY_ID_REQUEST,
    DOWNLOAD_BY_ID_SUCCESS,
    DOWNLOAD_BY_ID_ERROR,
    GET_SEARCH_RECENT_BIN_REQUEST,
    GET_SEARCH_RECENT_BIN_SUCCESS,
    GET_SEARCH_RECENT_BIN_ERROR,
};
